/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Billing_Period_StartInputs */

const en_settings_billing_period_start = /** @type {(inputs: Settings_Billing_Period_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Period start`)
};

const zh_settings_billing_period_start = /** @type {(inputs: Settings_Billing_Period_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`本期开始`)
};

/**
* | output |
* | --- |
* | "Period start" |
*
* @param {Settings_Billing_Period_StartInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_billing_period_start = /** @type {((inputs?: Settings_Billing_Period_StartInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Billing_Period_StartInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_billing_period_start(inputs)
	return zh_settings_billing_period_start(inputs)
});
export { settings_billing_period_start as "settings.billing.period_start" }